import React from 'react';

import { StyleSheet } from 'react-native';

import TrophyIcon from 'components/icons/trophy';
import { Box, Typography } from 'components/ui';
import { ChallengeContainer } from 'pages/loyalty/loyalty-rewards/loyalty-rewards.styled';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { primitive, spacing } from 'styles/constants';
import { isMobile } from 'utils/environment';

import { getQuestText } from './custom-text';
import { QuestActivationSource } from './loyalty-quest/quest-activation-source';
import { QuestCardError, QuestCardSkeleton } from './quest-card';
import { QuestCardWrapper } from './quest-card-wrapper';
import { QuestLibraryHeader } from './quests-library/quest-library-header';
import { useUserQuest } from './use-user-quest';

export const QuestSection = ({
  showHeader = true,
  showSmallHeader = false,
  activationSource = QuestActivationSource.UNKNOWN,
}: {
  showHeader?: boolean;
  showSmallHeader?: boolean;
  activationSource?: QuestActivationSource;
}) => {
  const { loyaltyUser } = useLoyaltyUser();
  const isQuestTilesEnable = useFlag(LaunchDarklyFlag.ENABLE_QUEST_TILES);
  const loyaltyId = loyaltyUser?.id;
  const { isLoading, error, refetch, userQuest, cmsQuestCardUI } = useUserQuest();

  if (!isQuestTilesEnable || !loyaltyId) {
    return null;
  }

  if (error) {
    return <QuestCardError refetch={refetch} />;
  }

  if (!userQuest || !cmsQuestCardUI) {
    return null;
  }

  if (isLoading) {
    return <QuestCardSkeleton />;
  }

  return (
    <ChallengeContainer addMargin={!showSmallHeader}>
      {showHeader &&
        (showSmallHeader ? (
          <Box style={styles.title}>
            <TrophyIcon width="24px" height="18px" />
            <Typography style={styles.titleText}>{getQuestText()}</Typography>
          </Box>
        ) : (
          <QuestLibraryHeader />
        ))}
      <QuestCardWrapper
        quest={userQuest.loyaltyQuest}
        cmsQuestCard={userQuest.cmsQuestCard}
        cmsQuestCardUI={cmsQuestCardUI}
        activationSource={activationSource}
      />
    </ChallengeContainer>
  );
};

const styles = StyleSheet.create({
  title: {
    flexDirection: 'row',
    marginBottom: isMobile() ? spacing.$3 : spacing.$4,
    gap: 8,
    alignItems: 'center',
  },
  titleText: {
    fontSize: primitive.fontSizes.lg,
    fontFamily: primitive.fontFamily.$headers,
    alignItems: 'flex-end',
    display: 'flex',
    color: primitive.$bbqBrown,
  },
});
